import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {AuthService} from '../auth.service';
import {AppConstants} from '../shared/app.constants';

@Injectable()
export class ShiftsService {

  constructor(private http: HttpClient, private auth: AuthService, private appConstants: AppConstants) {
  }

  getAllShifts(): Observable<any> {
    const url = environment.apiBase + 'shifts/admin';
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  getShift(shiftId): Observable<any> {
    const url = environment.apiBase + `shifts/${shiftId}`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  rotateShift(shiftId): Observable<any> {
    const url = environment.apiBase + `rotate/${shiftId}`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.put(url, {}, {headers: headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/shifts/shifts.service.ts